import { FC } from 'react'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined'
import { MainLayout } from 'views/layouts'
import {
  ModuleKpi,
  ModuleKpiAction,
  ModuleKpiContent,
  ModuleKpiGrid,
  ModuleKpiIcon,
  ModuleKpiLink,
  ModuleKpiTitle,
  ModulesPageHeader,
} from 'views/screens/Modules/styled'

const Home: FC = () => {
  return (
    <MainLayout>
      <ModulesPageHeader>
        <h2>Configuración de textos por Competencias</h2>
      </ModulesPageHeader>

      <ModuleKpiGrid>
        <ModuleKpiLink to="/modules/skills/texts/general">
          <ModuleKpi>
            <ModuleKpiIcon tone="blue">
              <ArticleOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Generales</ModuleKpiTitle>
              <ModuleKpiAction>Configurar →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>

        <ModuleKpiLink to="/modules/skills/texts/acording-to-result">
          <ModuleKpi>
            <ModuleKpiIcon tone="violet">
              <PsychologyOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Cualitativos</ModuleKpiTitle>
              <ModuleKpiAction>Configurar →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>
      </ModuleKpiGrid>
    </MainLayout>
  )
}

export default Home
